import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { CreateGrant$ } from "../schemas/schemas_0";
export { $Command };
export class CreateGrantCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("TrentService", "CreateGrant", {})
    .n("KMSClient", "CreateGrantCommand")
    .sc(CreateGrant$)
    .build() {
}
